declare var POLYFILLS_PATH: string;
declare var window: any;

import * as Sentry from '@sentry/browser';
import loadScript from './helpers/loadScript';
import shouldLoadPolyfills from './helpers/shouldLoadPolyfills';
import './polyfills/requestIdleCallback.js';
import './polyfills/isNaN.js';
import './polyfills/attachEvents.js';
import sentryBeforeSend from './sentryBeforeSend';

import general from './containers/general';

const csrfMetaTag: HTMLMetaElement = document.head.querySelector('meta[name="csrf-token"]');
const token = csrfMetaTag.content;

$.ajaxSetup({
  beforeSend: (xhr) => {
    xhr.setRequestHeader('X-CSRF-TOKEN', token);
  },
});

Sentry.init({
  dsn: window.ENV.SENTRY_DSN,
  ignoreErrors: [
    'top.GLOBALS',
    'document.getElementsByClassName.ToString',
    // https://github.com/getsentry/sentry/issues/5267
    /Blocked a frame with origin/,
    /ServiceWorker: An unknown error occurred/,
    /avast_submit/,
    /Niet nader omschreven fout/,
    /Failed to register a ServiceWorker/,
    'Object Not Found Matching Id',
    'The play() request was interrupted by a call to pause()',
    'AbortError: The operation was aborted',
    'Illegal invocation',
    '.validate is not a function', // Seems to occur on old Android versions.
    /evaluating 'b.container\[a\]'/,
    /jquery\(\"#form1102\"\)/,
    /vv\(\)\.getRestrictions/,
  ],
  denyUrls: [
    /graph\.facebook\.com/i,
    /connect\.facebook\.net\/en_US\/all\.js/i,
    /extensions\//i,
    /^chrome:\/\//i,
  ],
  beforeSend: sentryBeforeSend,
});

// Make sure these global variables exist
['POLYFILLS_PATH'].forEach((gl) => {
  if (typeof window[gl] === 'undefined') {
    throw new Error(`${gl} is not defined`);
  }
});

const ready = () => {
  general();
};

if (shouldLoadPolyfills()) {
  loadScript(POLYFILLS_PATH, ready);
} else {
  ready();
}

if ('serviceWorker' in navigator && window.isSecureContext !== false) {
  navigator.serviceWorker.register('/service-worker.js').catch((e) => {
    console.log('Service worker registration failed', e);
  });
}
